/**
 * @file order-menu-actions.ts
 * @description Второстепенные действия шапки карточки заказа данными
 * (phase19.24 §5, §14; phase19.31 — SC52, SC67).
 *
 * Главная кнопка одна (SC52), остальные действия — ВИДИМЫМИ кнопками рядом,
 * без меню «⋯» (SC67, «достань все кнопки из трёх точек»). Действие,
 * вынесенное в главную кнопку, второй раз не показывается. Пока доставку не
 * согласовали, «Подтвердить» и «К оплате» сервер отвергнет 409 — их нет
 * (правило «кнопки, гарантированно дающей 409, нет»).
 * Необратимое «Отменить заказ» — последним, в опасном тоне; причину
 * спрашивает окно `OrderCancelDialog`.
 */

import type { PageAction } from "../ui/page-actions";
import { orderPageActions } from "../ui/page-actions";
import type { OrderDto } from "../../lib/api-orders";
import { availableOrderActions, ORDER_ACTION_META, type OrderActionKey } from "../../lib/order-actions";
import type { OrderNowModel, ResolvedPrimaryAction } from "../../lib/order-now";

/**
 * Подписи кнопок шапки, которые отличаются от общего реестра: в меню «Отменить»
 * читалось в контексте заказа, отдельной кнопке нужно дополнение.
 */
const HEADER_LABEL: Partial<Record<OrderActionKey, string>> = {
  cancel: "Отменить заказ",
};

interface Input {
  order: OrderDto;
  now: OrderNowModel | null;
  primary: ResolvedPrimaryAction | null;
  canManage: boolean;
  acting: boolean;
  onAction: (action: OrderActionKey) => void;
  /** «Отменить» открывает окно с причиной — свой обработчик. */
  onCancel: () => void;
}

export function orderHeaderActions({ order, now, primary, canManage, acting, onAction, onCancel }: Input): PageAction[] {
  if (!canManage) return [];
  const actions = availableOrderActions({ status: order.status, agreementFirst: now?.agreementFirst ?? false })
    .filter((key) => key !== primary?.action)
    .map((key) => ({
      key,
      label: HEADER_LABEL[key] ?? ORDER_ACTION_META[key].label,
      icon: ORDER_ACTION_META[key].icon,
      danger: ORDER_ACTION_META[key].danger,
      disabled: acting,
      run: () => (key === "cancel" ? onCancel() : onAction(key)),
    }));
  // Опасное — последним.
  return orderPageActions(actions);
}
